import { PaymentMethod } from '@wix/cashier-common/dist/src/enums/payments/PaymentMethod';
import { PaymentProvider } from '@wix/cashier-common/dist/src/enums/payments/PaymentProvider';
import { type OnShippingMethodSelected } from '../../types/ExternalContract';
import { logGeneralError } from '../../utils/sentry';
import { amountToLong } from '../../utils/amountToLong';
import { applePayCallBackReceived } from '../../utils/bi/events/applePay';
import { type BiLogger } from '../../components/Provider/BiLogger/BiLogger';
import { transformPaymentBreakdownToApplePay, transformShippingMethodToCommon } from './applePayDataMapper';

/**
 * Handles shipping method change
 * @param consumerCallback OnShippingMethodSelected
 * @param data object
 */
export const shippingMethodSelectedHandler =
  (
    consumerCallback: OnShippingMethodSelected,
    data: { paymentLabel: string; appInstanceId: string; currencyCode: string },
    biLogger: BiLogger,
  ) =>
  async (event: ApplePayJS.ApplePayShippingMethodSelectedEvent) => {
    try {
      let biShippingMethod = '';
      try {
        biShippingMethod = JSON.stringify(event.shippingMethod);
      } catch {}

      const { paymentAmount, paymentBreakdown, orderItems } = await consumerCallback(
        transformShippingMethodToCommon(event.shippingMethod),
      );
      biLogger.report(applePayCallBackReceived, {
        checkoutType: 'express',
        newValue: biShippingMethod,
        amountLong: amountToLong(paymentAmount),
        appInstanceId: data.appInstanceId,
        fieldName: 'shippingMethod',
        currency: data.currencyCode,
        paymentProvider: PaymentProvider.WixPayUS,
        paymentmethod: PaymentMethod.ApplePay,

        orderSnapshotId: undefined as any, // TODO[bi]
        transactionId: undefined as any, // TODO[bi]
        isPartner: undefined as any, // TODO[bi]
        amount: undefined as any, // TODO[bi]
      });
      return {
        newTotal: { label: data.paymentLabel, amount: paymentAmount },
        newLineItems: transformPaymentBreakdownToApplePay(paymentBreakdown, orderItems),
      };
    } catch (err) {
      logGeneralError({
        message: '[ApplePay] shippingMethodSelectedHandler failed',
        payload: err,
      });
      throw err;
    }
  };
